type TAppInParams = {
  appID?: string;
};

export type TUpdateInfoError = {
  statusCode?: number;
  errorCode?: number;
  params?: {
    apps?: TAppInParams[];
    [key: string]: any;
  };
  [key: string]: any;
};

type HandleDuplicateStaffConflictForAppParams = {
  updateInfoError?: TUpdateInfoError;
  updateMemberRes?: any;
  appID: string;
  handleDuplicateStaffError: (response?: any) => boolean;
  retryPostSurveyInformation: (params?: any, isRetry?: boolean) => Promise<any>;
};

export const shouldHandleDuplicateStaffForApp = (
  updateInfoError: TUpdateInfoError | undefined,
  appID: string
) => {
  return Boolean(updateInfoError?.params?.apps?.some((app) => app?.appID === appID));
};

export const handleDuplicateStaffConflictForApp = async ({
  updateInfoError,
  updateMemberRes,
  appID,
  handleDuplicateStaffError,
  retryPostSurveyInformation,
}: HandleDuplicateStaffConflictForAppParams) => {
  if (!shouldHandleDuplicateStaffForApp(updateInfoError, appID)) {
    return false;
  }

  if (handleDuplicateStaffError(updateMemberRes)) {
    return true;
  }

  const shouldRetryFromInfoError =
    updateInfoError?.statusCode === 400 && updateInfoError?.errorCode === 1;
  if (!shouldRetryFromInfoError) {
    return false;
  }

  const retryError = await retryPostSurveyInformation(updateInfoError?.params, true);
  const isDuplicateStaffError = retryError?.statusCode === 400 && retryError?.errorCode === 1;
  if (!isDuplicateStaffError) {
    return false;
  }

  return handleDuplicateStaffError(retryError);
};
